<template>
  <div
    ref="contextMenu"
    class="menu"
    :style="styles"
    tabindex="0"
    @focusout="onClickBackground"
  >
    <div v-if="getTitle" class="header">
      {{ getTitle }}
    </div>
    <context-menu-item v-for="item in getItems" :id="item.id" :key="item.id" />
  </div>
</template>

<script>
import { cloneDeep } from 'lodash/fp';
import { mapGetters, mapActions } from 'vuex';
import { EVENT } from '../../constants.js';

import ContextMenuItem from './ContextMenuItem.vue';

export default {
  components: {
    'context-menu-item': ContextMenuItem,
  },

  directives: {
    eventoutside: {
      beforeMount(el, binding, vnode) {
        if (el.clickOutsideEvent === undefined) {
          el.clickOutsideEvent = [];
        }
        el.clickOutsideEvent[binding.arg] = event => {
          if (!(el === event.target || el.contains(event.target))) {
            if (Object.keys(binding.modifiers).includes('prevent')) {
              event.preventDefault();
            }
            if (Object.keys(binding.modifiers).includes('stop')) {
              event.stopPropagation();
            }
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener(
          binding.arg,
          el.clickOutsideEvent[binding.arg],
          { passive: false }
        );
      },
      unmounted(el, binding) {
        document.body.removeEventListener(
          binding.arg,
          el.clickOutsideEvent[binding.arg]
        );
      },
    },
  },

  data() {
    return {
      emitterClass: null,
      clickedEl: null,
      isHovered: false,
      clickedPosition: null,
      styles: {
        left: '0px',
        top: '0px',
      },
    };
  },

  computed: {
    ...mapGetters('application/contextMenu', [
      'getPosition',
      'getItems',
      'getOpenSubmenu',
      'getTitle',
    ]),
  },

  mounted() {
    const { left, top } = this.getPosition;
    this.repositionMenu(left, top);
    this.$refs.contextMenu.focus();
  },

  methods: {
    ...mapActions('application/contextMenu', ['deleteMenu']),

    /**
     * Event handler: Click on the overlay
     */
    onClickBackground(event) {
      if (!this.$refs.contextMenu?.contains(event.relatedTarget)) {
        this.deleteMenu();
      } else {
        this.$refs.contextMenu.focus();
      }
    },

    /**
     * Recalculate the menu position if it exceeds window bounds
     */
    repositionMenu(left, top) {
      const largestHeight =
        window.innerHeight - this.$refs.contextMenu.offsetHeight - 15;
      const largestWidth =
        window.innerWidth - this.$refs.contextMenu.offsetWidth - 30;
      if (top > largestHeight) top = largestHeight;
      if (left > largestWidth) left = largestWidth;
      const styles = { left: `${left}px`, top: `${top}px` };
      this.styles = styles;
    },
  },
};
</script>

<style scoped lang="scss">
.overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: auto;
  height: auto;
  z-index: 998;
}

.menu {
  position: fixed;
  z-index: 99999;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
  .header {
    font-size: 11px;
    padding: 10px 12px;
    color: rgba(255, 255, 255, 0.3);
    font-weight: 400;
    letter-spacing: 1px;
    background: #252929;
    text-transform: uppercase;
  }
}
</style>
